import React, { useEffect, createElement } from 'react';
import { CountdownBar } from './components/CountdownBar';
import { HeroSection } from './components/HeroSection';
import { PainPoints } from './components/PainPoints';
import { SolutionSection } from './components/SolutionSection';
import { BonusSection } from './components/BonusSection';
import { TargetAudience } from './components/TargetAudience';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PurchaseSection } from './components/PurchaseSection';
import { FAQSection } from './components/FAQSection';
import { SocialProofPopup } from './components/SocialProofPopup';
// Meta Pixel helper
const PIXEL_ID = '3070568583125644';
function initMetaPixel() {
  if (typeof window === 'undefined') return;
  if ((window as any).fbq) return; // already initialized
  const f: any = function (...args: any[]) {
    f.callMethod ? f.callMethod.apply(f, args) : f.queue.push(args);
  };
  f.push = f;
  f.loaded = true;
  f.version = '2.0';
  f.queue = [] as any[];
  (window as any).fbq = f;
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  const firstScript = document.getElementsByTagName('script')[0];
  if (firstScript && firstScript.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript);
  } else {
    document.head.appendChild(script);
  }
  ;
  (window as any).fbq('init', PIXEL_ID);
  (window as any).fbq('track', 'PageView');
}
function trackEvent(eventName: string) {
  if (typeof window !== 'undefined' && (window as any).fbq) {
    ;
    (window as any).fbq('track', eventName);
  }
}
export function App() {
  useEffect(() => {
    // Initialize Meta Pixel via direct script injection
    try {
      initMetaPixel();
    } catch (e) {
      console.warn('Meta Pixel initialization failed:', e);
    }
    // Track checkout clicks
    const handleCheckoutClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      if (target.closest('a[href*="hotmart.com"]')) {
        trackEvent('InitiateCheckout');
      }
    };
    document.addEventListener('click', handleCheckoutClick);
    return () => document.removeEventListener('click', handleCheckoutClick);
  }, []);
  return <div className="min-h-screen bg-white font-sans text-gray-900 overflow-x-hidden" data-id="element-0">
      <CountdownBar data-id="element-1" />

      <main className="pt-[48px] md:pt-[52px]" data-id="element-2">
        {' '}
        {/* Offset for fixed countdown bar */}
        <HeroSection data-id="element-3" />
        <PainPoints data-id="element-4" />
        <SolutionSection data-id="element-5" />
        <BonusSection data-id="element-6" />
        <PurchaseSection data-id="element-7" />
        <TargetAudience data-id="element-8" />
        <TestimonialsSection data-id="element-9" />
        <FAQSection data-id="element-10" />
      </main>

      <footer className="bg-[#0F172A] text-gray-400 py-8 text-center text-sm border-t border-gray-800" data-id="element-11">
        <div className="max-w-7xl mx-auto px-4" data-id="element-12">
          <p className="mb-2" data-id="element-13">
            © {new Date().getFullYear()} MegaPack Educación Física LISTA™.
            Todos los derechos reservados.
          </p>
          <p data-id="element-14">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio no está respaldado por Facebook de ninguna
            manera.
          </p>
        </div>
      </footer>

      <SocialProofPopup data-id="element-15" />
    </div>;
}